






import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      shown: false,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    open() {
      setTimeout(() => {
        this.shown = true;
      }, 0);
    },
    close() {
      console.log("closeeeeeeeeeeeeeeeeeeeeeeeeeee");

      this.shown = false;
    },
  },
  mounted() {
    this.shown = this.show;
  },
  watch: {
    show() {
      console.log(this.show);
    },
    shown() {
      console.log(this.show);
      console.log(this.shown);
    },
  },
});
